import React from "react";
import { AiFillHome } from "react-icons/ai";
import { BsFillPlayBtnFill } from "react-icons/bs";
import { BsFillBookmarkFill } from "react-icons/bs";
import { MdHPlusMobiledata } from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";

import PATH from "../../constants/routes";

import "./SidebarFooter.scss";
import { Link } from "react-router-dom";
import useActivePath from "../../CustomHooks/useActivePath";

export default function SidebarFooter() {
  const { urlPaths, checkActive } = useActivePath();

  return (
    <div className="sidebar_footer">
      <ul>
        <Link className={`home ${checkActive("")} `} to={PATH.HOMEPAGE}>
          <li>
            <AiFillHome />
            <p>Home</p>
          </li>
        </Link>

        <Link className={`videos ${checkActive(PATH.VIDEOS)}`} to={PATH.VIDEOS}>
          <li>
            <BsFillPlayBtnFill />
            <p>Videos</p>
          </li>
        </Link>

        <Link className={`qbank ${checkActive(PATH.QBANK)} `} to={PATH.QBANK}>
          <li>
            <BsFillBookmarkFill />
            <p>QBank</p>
          </li>
        </Link>

        <Link className="tests" to={PATH.TESTS}>
          <li>
            <MdHPlusMobiledata />
            <p>Tests</p>
          </li>
        </Link>
        <Link className="profile" to={PATH.QBANK}>
          <li>
            <BsFillPersonFill />
            <p>Me</p>
          </li>
        </Link>
      </ul>
    </div>
  );
}
